import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-active",
  "use": "icon-active-usage",
  "viewBox": "0 0 48.2 54.2",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 48.2 54.2\" id=\"icon-active\">\n<style type=\"text/css\">\n</style>\n<path class=\"st0\" d=\"M43.6,30c6.4-7.8,5.2-19.3-2.7-25.7C33.5-1.7,22.5-1,16,6.1c-2.8,3.3-4.3,7.5-4.3,11.8\n\tc-0.1,2.1,0.2,4.3,0.8,6.3L3.2,41.1c-1.2,2.2-1,4.9,0.5,6.9l-2.9,3.3C0.3,52,0.3,53,1,53.6c0,0,0,0,0,0c0.3,0.2,0.7,0.4,1,0.4\n\tc0.5,0,0.9-0.2,1.2-0.6l2.9-3.5c0.8,0.4,1.8,0.6,2.7,0.6c1.6,0,3.2-0.6,4.3-1.7l13.9-12.6c0.9,0.1,1.8,0.2,2.7,0.2\n\tc5.3,0,10.3-2.3,13.7-6.3L43.6,30z M44.8,18.1c0,3.1-0.9,6.1-2.7,8.6L19.4,7.2c6-5.7,15.5-5.5,21.3,0.5\n\tC43.3,10.5,44.8,14.3,44.8,18.1z M11,46.5c-1.3,1.2-3.3,1.2-4.5-0.1c-1-1-1.2-2.6-0.5-3.8l8.7-15.7l9.3,7.6c0,0.1,0,0.1,0,0.2\n\tL11,46.5z M27.1,33.1l-11.5-9.4c-0.7-1.7-1-3.5-1-5.4c0-3,1-6,2.7-8.5l22.7,19.5c-2.8,2.6-6.4,4.1-10.2,4.1\n\tc-0.8-0.1-1.7-0.2-2.5-0.5L27.1,33.1z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/active.svg
// module id = MWzP
// module chunks = 59